/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import axios from "axios";
import { APIGateways } from "../utility/APIGateways";
import { getAuthHeader } from "../utility/auth";
import { v2, errorToObject } from "@prftesp/cle-logger";
import errorCodes from "../utility/errorCodes";

const COMPONENT_NAME = "Admin sharedServices/configService";

export const updateConfigValue = async (settingName, settingValue) => {
	const updateObject = {};
	updateObject[settingName] = settingValue;
	return await updateConfigValues(updateObject);
};

export const updateConfigValues = async (configUpdateObject) => {
	try {
		let updateResponse = await axios.put(`${APIGateways.configEndpoint}`, configUpdateObject, {
			headers: await getAuthHeader(),
		});
		return updateResponse.data;
	} catch (error) {
		v2.error(`Error updating config value`, {
			additionalData: { error: errorToObject(error), data: { configUpdateObject } },
			componentName: COMPONENT_NAME,
			logCode: errorCodes.UPDATE_CONFIG_API_ERROR,
		});
		throw error;
	}
};

export const getConfigValue = async (settingName) => {
	return await getConfigValues([settingName]);
};

export const getConfigValues = async (settingNames) => {
	try {
		let config = await axios.post(`${APIGateways.configEndpoint}`, settingNames, {
			headers: await getAuthHeader(),
		});
		return config.data.results;
	} catch (error) {
		v2.error(`Error getting config values`, {
			additionalData: { error: errorToObject(error), data: { settingNames } },
			componentName: COMPONENT_NAME,
			logCode: errorCodes.GET_CONFIG_API_ERROR,
		});
		throw error;
	}
};
